<template>
  <div class="card project_panel" style="border: 0; margin-bottom: 0.5rem" @click="onProjectClick()">
    <div class="card-body">
      <div class="row row-cols-2 no-gutters">
        <div class="project_leftside col" style="justify-content: center">
          <img class="project_image" :src="urls.getThumbnailURL(publicPage.user.id, publicPage)" alt="投稿画像" />
        </div>

        <!--/*  タイトルなど  */-->
        <div class="project_rightside d-felx col" style="flex-direction: column">
          <!--/*  タイトル  */-->
          <div class="h5 project_title" style="margin-left: 0.25rem; margin-bottom: 0">
            {{ publicPage.title }}
          </div>

          <!--/*  ユーザー名  */-->
          <div v-if="publicPage.user != null">
            <UserBlock :dtoUser="publicPage.user"></UserBlock>
          </div>

          <!--/*  project説明文  */-->
          <div class="project_description col-auto">
            {{ publicPage.description }}
          </div>
          <!--/*  投稿日時  */-->
          <small>{{ publicPage.createdAt }}</small>

          <!--/*  いいね数などの表示 */-->
          <div class="row" style="display: flex">
            <!--/*  like数  */-->
            <div class="col-6" v-if="publicPage.goodCount != null">
              <span>
                <svg viewBox="0 0 16 16" width="1em" height="1em" class="bi-heart-fill heart_icon b-icon bi" fill="currentColor">
                  <use :xlink:href="urls.getIconURL('heart-fill-pink')" />
                </svg>

                {{ publicPage.goodCount }}
              </span>
            </div>
            <!--/*  コメント数  */-->
            <div class="col-6" v-if="publicPage.commentsCount != null">
              <span>
                <svg viewBox="0 0 16 16" width="1em" height="1em" class="bi-heart-fill heart_icon b-icon bi">
                  <use :xlink:href="urls.getIconURL('chatleft')" />
                </svg>
                {{ publicPage.commentsCount }}
              </span>
            </div>
            <!--/*  ビュー数  */-->
            <div class="col-6" v-if="publicPage.viewCount != null">
              <span>
                <svg viewBox="0 0 16 16" width="1em" height="1em" class="bi-eye-fill b-icon bi">
                  <use :xlink:href="urls.getIconURL('eye-fill')" />
                </svg>
                {{ publicPage.viewCount }}
              </span>
            </div>
            <!--/*  good 数  */-->
            <div class="col-6" v-if="publicPage.anonymousGoodCount != null">
              <span>
                <svg viewBox="0 0 16 16" width="1em" height="1em" class="bi-shift-fill b-icon bi">
                  <use :xlink:href="urls.getIconURL('shift-fill')" />
                </svg>
                {{ publicPage.anonymousGoodCount }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';

import PublicPageResp from "@/interface/api/PublicPageResp";
import UserBlock from "@/component/parts/UserBlock.vue";
import RootVue from '@/RootVue.vue';
import routeState from "@/state/RouteState";
import urls from "@/URLs";


@Options({
  components: {
    UserBlock,
  },
  props: {
    publicPage: {
      type: Object,
    },
  },
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  readonly publicPage!: PublicPageResp;
  readonly urls = urls;
  
  projectImageSample = null;

  onProjectClick() {
    routeState.goToPublicPage(this.publicPage);
  }
  
}
</script>


<style lang="scss" scoped>
/* プロジェクト */
/* プロジェクト */
.project_panel {
  min-height: 200px;
  cursor: pointer;
  background-color: white;
}

.project_image {
  max-width: 100px;
  height: 200px;
  object-fit: cover;
}

.project_rightside {
  max-height: 200px;
}

.heart_icon {
  color: palevioletred;
}

.project_description {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project_title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>